import { API, APIObject } from '@/shared/plugins/Api/API'
import _omit from 'lodash/omit'
import _set from 'lodash/set'

class TrinoConnector extends APIObject {
  constructor (options) {
    super('DM', options)

    this._id = this._id || ''
    this.display_name = this.display_name || ''
    this.name = this.name || ''
    this.description = this.description || ''
    this.tags = this.tags || {}
    this.tags.path = this.tags?.path || ''
    this.tags.tags = this.tags?.tags || []
    this.created_by = this.created_by || ''
    this.updated_at = this.updated_at || ''
    this.consumer_type = this.consumer_type || 'trino'
    this.parameters = this.parameters || {}
    this.parameters.permission = this.parameters.permission || 'read'
    // NOTE: configuration.logo is a frontend-only default — the API response does not include a logo.
    this.configuration = this.configuration || {}
    this.configuration.logo = this.configuration.logo || require('@/qb/assets/img/trino-logo.png')
  }

  _filter (object) {
    const obj = _omit(super._filter(object), [
      '_id',
      'createdAt',
      'updatedAt',
      'createdBy',
      'updatedBy',
      'name'
    ])
    return obj
  }

  async create () {
    return super.create({
      method: 'POST',
      url: 'v4/consumer/trino',
      data: {
        display_name: this.display_name,
        description: this.description,
        tags: this.tags || {},
        parameters: {
          permission: this.parameters?.permission || 'read'
        }
      }
    })
  }

  async save () {
    return super.save({
      method: 'PUT',
      url: `v4/consumer/${this._id}`,
      data: {
        parameters: {
          permission: this.parameters?.permission || 'read'
        }
      }
    })
  }

  async remove () {
    return this.request({
      method: 'DELETE',
      url: `v4/consumer/${this._id}`
    })
  }
}

class TrinoConnectors extends API {
  new (queryString) {
    const item = {}
    for (const key in queryString) {
      _set(item, key, queryString[key])
    }
    return new TrinoConnector(item)
  }
}

export default TrinoConnectors
export {
  TrinoConnector,
  TrinoConnectors
}
